// extracted by mini-css-extract-plugin
export default {"bulkLoadCulturePlatesAction":"bulkLoadCulturePlatesAction-FI10j","header":"header-O7uqs","stepper":"stepper-iILB6"};